<template>
  <label>
    Specifications
    <select
      :value="value"
      class="font16"
      :disabled="disabled"
      @input="$emit('input', $event.target.value)"
      id="specifications_select"
    >
      <option selected disabled value />
      <option
        v-for="(specification, index) in specifications"
        :key="index"
        :value="specification"
      >
        {{ specification }}
      </option>
    </select>
  </label>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    fabricatedProduct: {
      type: Boolean,
      required: true
    },
    gradeAlloy: {
      type: String,
      required: true
    },
    productForm: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedSpecification: null,
      specifications: []
    };
  },
  watch: {
    gradeAlloy() {
      if (this.gradeAlloy === "") {
        return;
      }

      if (this.fabricatedProduct) {
        this.getSpecificationsFabricated();
      } else {
        this.getSpecifications();
      }
    }
  },
  methods: {
    ...mapMutations(["setLoading"]),
    getSpecifications() {
      this.setLoading(true);

      this.$axios
        .post("/shop/quick_quote/specifications.json", {
          form: this.productForm,
          grade: this.gradeAlloy
        })
        .then(response => {
          this.$store.commit("updateVariantIds", {
            filter: "specification",
            variantIds: response.data.variantIds
          });
          this.specifications = response.data.specs;
          this.setLoading(false);
        });
    },
    getSpecificationsFabricated() {
      this.setLoading(true);

      this.$axios
        .post("/shop/quick_quote/specifications_fabricated.json", {
          form: this.productForm,
          grade: this.gradeAlloy
        })
        .then(response => {
          this.$store.commit("updateVariantIds", {
            filter: "specification",
            variantIds: response.data.variantIds
          });
          this.specifications = response.data.specs;

          if (this.specifications.length === 1) {
            this.$emit("input", this.specifications[0]);
          }

          this.setLoading(false);
        });
    }
  }
};
</script>

<style scoped>
select {
  text-overflow: ellipsis;
}
</style>
